import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "@shared/utils/request";

import config from "../../config";

export type GetOneCouponResponse = {
  id: number;
  name: string;
  value: string;
  description: string;
};

export type GetOneCouponRequest = {
  name?: string;
};

export const couponApi = createApi({
  reducerPath: "couponApi",
  baseQuery: axiosBaseQuery({
    baseUrl: config.baseApiUrl,
  }),
  tagTypes: ["Coupons"],
  endpoints: (builder) => ({
    getOneCoupons: builder.query<GetOneCouponResponse, GetOneCouponRequest>({
      query: (args) => {
        return {
          url: `coupons/${args.name}`,
        };
      },
    }),
  }),
});

export const { useGetOneCouponsQuery } = couponApi;
